export default __webpack_public_path__ + "static/1585-e15bc9c087501accf5a782dda1526d5e.gif";